import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles scrolling on navigation:
 *  - hash → smooth scroll to element with matching id
 *  - no hash → scroll to top
 * React Router v6 does not do this by default.
 */
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // small delay to let route render
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
